import type { Option } from '@/types/option'
import { getTenantByCookies } from '@/utils/getTenantByCookies'
import { httpClient } from '../../httpClient'

type InvestmentOvertimeHttpResponse = {
  ROIEstimated: { month: string; value: number }[]
  ROIValidated: { month: string; value: number }[]
}

type Params = {
  date?: Date
}

type Response = {
  estimated: Option<number>[]
  validated: Option<number>[]
}

const getDashboardInvestmentOvertime = async ({
  date,
}: Params): Promise<Response> => {
  const tenant = await getTenantByCookies()

  if (tenant?.slug === 'trial') {
    return {
      estimated: [
        {
          label: 'Jan/2025',
          value: 10,
        },
        {
          label: 'Fev/2025',
          value: 20,
        },
      ],
      validated: [
        {
          label: 'Jan/2025',
          value: 30,
        },
        {
          label: 'Fev/2025',
          value: 15,
        },
      ],
    }
  }

  const queryParams = new URLSearchParams({
    ...(date && { date: date.toISOString() }),
  })

  const query = queryParams.toString() ? `?${queryParams.toString()}` : ''

  const { data } = await httpClient.get<InvestmentOvertimeHttpResponse>(
    `/ideas/dashboard/overtime${query}`,
  )

  return {
    estimated: data.ROIEstimated.map(({ month, value }) => ({
      label: month,
      value,
    })),
    validated: data.ROIValidated.map(({ month, value }) => ({
      label: month,
      value,
    })),
  }
}

export { getDashboardInvestmentOvertime }
